export { default as Modal } from './Modal'
export { default as ConfirmationModal } from './ConfirmationModal'
export { default as StatusModal } from './StatusModal'
export * as StyledModal from './Modal.styles'
export type { ModalProps } from './Modal'
export type { ComponentProps as ConfirmationModalProps } from './ConfirmationModal'
export type { ComponentProps as StatusModalProps } from './StatusModal'
